import React from "react";
import { MdDelete } from "react-icons/md";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom/cjs/react-router-dom.min";


export default function ProductCart({ product,removeCart,className,isCheckOut=false }) {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  
  
  return (
    <div className={`w-full xl:p-4 flex gap-2 justify-start items-start bg-white group/card h-36 ${className} `}>
      <Link to={`/products/${product.product}?ref=${userInfo?.userInfo?.address??""}`} className="relative border rounded-xl shadow-sm overflow-hidden  w-[100px] h-[100px]">
        <img
          src={product.image?.["url"]}
          alt={product.name}
          className="w-full h-full object-cover"
        />
       

      </Link>

      <div className="flex flex-col gap-1 items-start w-[calc(100%-130px)]">
        <h3 className="text-sm font-semibold line-clamp-2 text-left hover:text-[--color-button-3] transition-all duration-150 leading-5 h-[40px]   "> <Link to={`/products/${product.product}`}>{product.name}</Link></h3>

        <div className="flex items-center gap-1">
          <span className="flex w-1/3 xl:w-auto text-sm xl:text-base font-bold text-red-600">
            {product?.qty?.toFixed(0)}
          </span>
          <span className="flex  w-1/3 xl:w-auto text-sm  font-bold text-black">
            x
          </span>
          <span className="flex justify-center  xl:w-auto  text-sm font-bold px-[5px] py-[1px] rounded-md">
            {product?.price.toFixed(2)}
          </span>
        </div>
      </div>

   {!isCheckOut &&    <button className=" w-[30px] text-base font-medium px-2 py-1 rounded-full transition-all duration-300" onClick={()=>removeCart(product.product)}>
       <MdDelete className="text-red-700"/>
      </button>}
    </div>
  );
}
